export const PUBLICATION_STAGES = {
    checking: ["Checking existing video…", "正在檢查既有影片…"],
    captions: ["Fetching captions…", "正在取得字幕…"],
    downloading: ["Downloading audio…", "正在下載音訊…"],
    loading_model: ["Loading speech model…", "正在載入語音模型…"],
    transcribing: ["Transcribing audio…", "正在轉寫音訊…"],
    indexing: ["Creating chapters…", "正在建立章節…"],
    publishing: ["Saving searchable video…", "正在儲存影片索引…"],
};

const ERRORS = {
    transcript_unavailable: ["Captions are unavailable and audio transcription is disabled.", "無法取得字幕，目前未啟用音訊轉寫。"],
    audio_unavailable: ["The audio could not be downloaded. Check that the video is available and within the duration limit.", "無法下載音訊，請確認影片可存取且未超過長度限制。"],
    asr_unavailable: ["Audio transcription is unavailable. Please try again later.", "音訊轉寫目前無法使用，請稍後再試。"],
    asr_quality: ["The audio did not produce a usable transcript. Review the source video.", "音訊未能產生可用的逐字稿，請檢查影片內容。"],
    asr_timeout: ["Audio transcription exceeded the time limit.", "音訊轉寫已超過時間上限。"],
    asr_busy: ["Another video is being transcribed. Try again after it finishes.", "另一支影片正在轉寫，請等完成後再試。"],
    video_busy: ["This video is already being processed. Check its status before retrying.", "這支影片正在處理，請先確認狀態再重試。"],
    unsupported_language: ["Only Chinese, English and Japanese audio are supported.", "目前僅支援中文、英文與日文音訊。"],
    publication_timeout: ["Processing exceeded the time limit. Refresh the library before retrying.", "處理已超過時間上限，請先重新整理清單再重試。"],
};

export function publicationErrorMessage(code, language) {
    return ERRORS[code]?.[language === "zh" ? 1 : 0];
}

export function parsePublicationStream(text, complete = false) {
    if (typeof text !== "string" || text.length > 1_000_000) throw new Error("Invalid publication stream");
    const lines = text.split("\n");
    if (!complete) lines.pop();
    let stage = null, result = null, error = null;
    for (const line of lines) {
        if (!line.trim()) continue;
        if (result || error) throw new Error("Unexpected data after publication finished");
        const frame = JSON.parse(line);
        if (frame.type === "progress" && Object.hasOwn(PUBLICATION_STAGES, frame.stage)) stage = frame.stage;
        else if (frame.type === "heartbeat") continue;
        else if (frame.type === "result" && frame.data && typeof frame.data === "object") result = frame.data;
        else if (frame.type === "error" && typeof frame.error === "string") error = frame;
        else throw new Error("Invalid publication event");
    }
    if (complete && !result && !error) throw new Error("Publication ended without confirmation. Refresh the library before retrying.");
    return { stage, result, error };
}
